import { EvsRecord } from './evsRecord';

export interface ILesson {
  id: string;
  type: string;
  created_at: string;
  starts_at: string;
  ends_at: string;
  cancelled_at: string;
  declined_at: string;
  confirmed_at: string;
  status: string;
  amount: number;
  credits: number;
  duration: number;
  driving_exam_id: number;
  teacher: object;
  departure_point: object;
  arrival_point: object;
  automatic: boolean;
  teacher_reported_absent: boolean;
}

export class Lesson extends EvsRecord implements ILesson {
  id: string;
  type: string;
  created_at: string;
  starts_at: string;
  ends_at: string;
  cancelled_at: string;
  declined_at: string;
  confirmed_at: string;
  status: string;
  amount: number;
  credits: number;
  duration: number;
  driving_exam_id: number;
  teacher: object;
  departure_point: object;
  arrival_point: object;
  automatic: boolean;
  teacher_reported_absent: boolean;

  constructor(obj: ILesson) {
    super(obj);
  }
}

export type LessonTeacher = {
  id: string;
  first_name: string;
  last_name: string;
  picture_url: string;
  phone_number: string;
};

export type LessonLocation = {
  address: string;
  latitude: number;
  longitude: number;
};

export type LessonStudent = {
  id: string;
  first_name: string;
  last_name: string;
};

export type LessonVehicle = {
  brand: string;
  model: string;
  registration: string;
};

export type LessonDrivingExam = {
  start_at?: string | null;
};

export interface ILessonV3 {
  id: string;
  start_at: string;
  end_at: string;
  location: LessonLocation;
  student: LessonStudent;
  teacher: LessonTeacher;
  vehicle: LessonVehicle;
  driving_exam: LessonDrivingExam;
}

export class LessonV3 extends EvsRecord implements ILessonV3 {
  id: string;
  start_at: string;
  end_at: string;
  location: LessonLocation;
  student: LessonStudent;
  teacher: LessonTeacher;
  vehicle: LessonVehicle;
  driving_exam: LessonDrivingExam;

  constructor(obj: ILessonV3) {
    super(obj);
  }
}
